import { useNavigate, Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-stone-950 text-stone-100 relative">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(900px_circle_at_50%_0%,rgba(34,211,238,0.1),transparent_55%)]" />
      <Navigation />
      <div className="relative flex min-h-[70vh] items-center justify-center px-4 py-16 sm:px-6 lg:px-8">
        <div className="w-full max-w-md text-center card-glass rounded-3xl border border-white/10 p-10">
          <h1 className="text-4xl font-semibold tracking-tight text-white">Unauthorized</h1>
          <p className="mt-4 text-stone-400">You do not have permission to view this page.</p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
            <button
              type="button"
              onClick={() => navigate('/dashboard')}
              className="rounded-xl bg-cyan-400 px-6 py-3 text-sm font-semibold text-slate-950 hover:bg-cyan-300 transition-colors"
            >
              Go to dashboard
            </button>
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-xl border border-white/15 bg-white/5 px-6 py-3 text-sm font-semibold text-stone-100 hover:bg-white/10 transition-colors"
            >
              Home
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Unauthorized;
